class CollectionTab{
    constructor(){
        this.init()
    }
    initSwiper = (item) =>{
        
        let settings = {
            loop: true,
            slidesPerView: 1,
            autoHeight: true,
            spaceBetween: 20,
            navigation:{
                nextEl: item.querySelector('.swiper-button-next'),
                prevEl: item.querySelector('.swiper-button-prev')
            },
            breakpoints: {
                768: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                }
            },
        }
        const swiper = new Swiper(item, settings);
    }
    clickEvent = () =>{
        const liElements = document.querySelectorAll('.home-new-tab-sec ul.tabs li');
        liElements.forEach((li)=>{
            li.addEventListener('click',(e)=>{
                let parent = li.closest('.home-new-tab-sec');
                let sliders = parent.querySelectorAll('.tab_content')
                sliders.forEach((item)=> item.classList.remove('active'));
                
                var activeTab = li.dataset.item;
                let target = parent.querySelector(`.tab_content[data-item="${activeTab}"]`);
                if(target){
                    target.classList.add('active');
                    if(!target.classList.contains('.swiper-initialized')){
                        this.initSwiper(target);
                    }
                }
                let tabsLI = parent.querySelectorAll("ul.tabs li");
                tabsLI.forEach((item)=> item.classList.remove('active'));
                li.classList.add('active')
            })
            
        })
    }
    init = () =>{
        let items = document.querySelectorAll('.home-new-tab-sec');
        items.forEach((item)=>{
            let tab_content = document.querySelector('.tab_content')
            this.initSwiper(tab_content);
        })
        this.clickEvent();
    }
}

if(document.querySelector('.home-new-tab-sec .swiper')) new CollectionTab();